









import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class VDraggableListItem extends Vue {}
